import { useQuery } from '@tanstack/react-query';
import { surveyAuditApi } from '../api/surveyAuditApi';
import { surveyAuditQueryKeys } from './queryKeys';
import { UseAuditProgressOptions } from '../types';

// Hook for getting audit progress with polling
export const useAuditProgress = (auditId: string, options?: UseAuditProgressOptions) => {
  return useQuery({
    queryKey: surveyAuditQueryKeys.progress(auditId),
    queryFn: () => surveyAuditApi.getAuditProgress(auditId),
    enabled: options?.enabled !== false && !!auditId,
    refetchInterval: options?.pollInterval || 30000, // Poll every 30 seconds by default
    refetchIntervalInBackground: true,
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};

// Hook for getting audit trail
export const useAuditTrail = (auditId: string, enabled = true) => {
  return useQuery({
    queryKey: surveyAuditQueryKeys.trail(auditId),
    queryFn: () => surveyAuditApi.getAuditTrail(auditId),
    enabled: enabled && !!auditId,
    staleTime: 5000, // Audit trail changes frequently during active audit
  });
};

// Hook for getting audit statistics
export const useAuditStatistics = (auditId: string, enabled = true) => {
  return useQuery({
    queryKey: surveyAuditQueryKeys.statistics(auditId),
    queryFn: () => surveyAuditApi.getAuditStatistics(auditId),
    enabled: enabled && !!auditId,
    refetchInterval: 60000, // Refresh statistics every minute
    staleTime: 30000,
  });
};
